import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PatientForm from '../InformationsForms/PatientForm';
import EmployerForm from '../InformationsForms/EmployerForm';
import ReferredByForm from '../InformationsForms/ReferredByForm';
import ProceduresForm from '../InformationsForms/ProceduresForm';
import SpecialInstructions from '../InformationsForms/SpecialInstructions';
import { logout } from '../../utils/helpers';
import { mainContext } from '../../context/context';
import { CAPTCHA_SITE_KEY, baseUrl } from '../../common/constants';
import { toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";
import { Content } from 'antd/es/layout/layout';
import { Button, Row } from 'antd';
import styles from './openAccess.module.scss'

const OpenAccessPatientForm = () => {
    logout();
    const { formDataValues, setErrors, errors,getFormData,resetFormData } = React.useContext(mainContext);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [isDirty, setIsDirty] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateFormData = () => {
        // Select all input, textarea, and Ant Design select wrappers
        const inputs = document.querySelectorAll('input, textarea, select, .ant-select');
        let hasError = false;
        const handledRadioGroups = new Set();
        const errorClass = 'custom-required-error';
        const redBorderStyle = '1px solid red';
        const defaultBorderStyle = '';
        let firstErrorInput = null;

        inputs.forEach(input => {
            // For Ant Design Select, get the value from the hidden input
            if (input.classList.contains('ant-select')) {
                const formItemRow = input.closest('.ant-form-item-row');
                if (!formItemRow) return;
                const required = formItemRow.querySelector('.ant-form-item-required');
                if (!required) return;

                // Find the hidden input that holds the value
                const hiddenInput = input.querySelector('input[aria-hidden="true"], input[type="hidden"]');
                // Or get the value from the ant-select-selection-item
                const selectedValue = input.querySelector('.ant-select-selection-item')?.textContent || '';
                const _labelText = formItemRow.querySelector('.ant-form-item-label')?.textContent || '';
                const cleanLabel = _labelText.replace(/^[a-z]\.\s*/i, '').trim();
                const title = cleanLabel || 'This field';

                const removePreviousError = (targetEl) => {
                    const existingError = targetEl.querySelector(`.${errorClass}`);
                    if (existingError) existingError.remove();
                };

                const showError = (targetEl, inputRef) => {
                    removePreviousError(targetEl);
                    const errorDiv = document.createElement('div');
                    errorDiv.className = errorClass;
                    errorDiv.style.color = 'red';
                    errorDiv.style.fontSize = '12px';
                    errorDiv.style.marginTop = '4px';
                    errorDiv.textContent = `${title} is required.`;
                    targetEl.appendChild(errorDiv);

                    if (!firstErrorInput && inputRef) {
                        firstErrorInput = inputRef;
                    }
                };

                // If no value selected or value is empty
                if (!selectedValue || selectedValue === '--Select--') {
                    hasError = true;
                    showError(input.parentNode, input);
                    input.style.border = redBorderStyle;
                } else {
                    removePreviousError(input.parentNode);
                    input.style.border = defaultBorderStyle;
                }
                return;
            }

            const formItemRow = input.closest('.ant-form-item-row');
            if (!formItemRow) return;

            const required = formItemRow.querySelector('.ant-form-item-required');
            if (!required) return;

            // Skip input[type="search"]
            if (input.tagName === 'INPUT' && input.type === 'search') return;

            const _labelText = formItemRow.querySelector('.ant-form-item-label')?.textContent || '';
            const cleanLabel = _labelText.replace(/^[a-z]\.\s*/i, '').trim();
            const title = cleanLabel || input.getAttribute('placeholder') || 'This field';

            const removePreviousError = (targetEl) => {
                const existingError = targetEl.querySelector(`.${errorClass}`);
                if (existingError) existingError.remove();
            };

            const showError = (targetEl, inputRef) => {
                removePreviousError(targetEl);
                const errorDiv = document.createElement('div');
                errorDiv.className = errorClass;
                errorDiv.style.color = 'red';
                errorDiv.style.fontSize = '12px';
                errorDiv.style.marginTop = '4px';
                errorDiv.textContent = `${title} is required.`;
                targetEl.appendChild(errorDiv);

                // Save the first input for scroll + focus
                if (!firstErrorInput && inputRef) {
                    firstErrorInput = inputRef;
                }
            };

            // Handle radio buttons
            if (input.type === 'radio') {
                if (handledRadioGroups.has(input.name)) return;
                handledRadioGroups.add(input.name);

                const group = document.querySelectorAll(`input[type="radio"][name="${input.name}"]`);
                const anyChecked = Array.from(group).some(radio => radio.checked);
                const formItem = input.closest('.ant-form-item');

                if (!anyChecked && formItem) {
                    hasError = true;
                    showError(formItem, input);
                } else if (formItem) {
                    removePreviousError(formItem);
                }
            }

            // Handle all other inputs
            else {
                if (!input.value) {
                    hasError = true;
                    showError(input.parentNode, input);
                    input.style.border = redBorderStyle;
                } else {
                    removePreviousError(input.parentNode);
                    input.style.border = defaultBorderStyle;
                }
            }
        });

        if (firstErrorInput) {
            firstErrorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorInput.focus();
        }

        return !hasError;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = validateFormData();
        if (!isValid) {
            toast.error("Please fill all required fields.");
            return;
        }
        const { patientInfo, employeeInfo, referredByInfo, proceduresInfo, specialInstruction } = formDataValues;
        const {firstName , lastName , claimNumber , wcbNumber ,dateOfInjury ,injury , gender , dateOfBirth ,height, weight,
            mobile,patient_address1, patient_address2, altenatePhone , patient_city , email, feet , inches , languages , patient_state, phone3, phone4 , patient_zip, alternateDescription,
            phone1,  preferredLanguage,isTranslationRequired, isTransportationRequired, isRush  ,alternatePhone } = patientInfo
        
        const PatientFormValues = {firstName , lastName , claimNumber , wcbNumber ,dateOfInjury ,injury , gender , dateOfBirth ,height, weight,
            mobile,patient_address1, patient_address2, altenatePhone , patient_city , email, feet , inches , languages , patient_state, phone3, phone4 , patient_zip, alternateDescription,
            phone1, alternatePhone, preferredLanguage,isTranslationRequired, isTransportationRequired, isRush   }
        
    
        const formattedPatientInfo = patientInfo?.feet && patientInfo?.inches ? {
            ...PatientFormValues,
            height: {
                feet: patientInfo?.feet,
                inches: patientInfo?.inches
            },
            languages:[patientInfo?.language],
        } : patientInfo;
    


        try {
            const response = await axios.post(`${baseUrl}/openAccess/`, {
                patientInfo: formattedPatientInfo,
                employeeInfo: formDataValues?.employeeInfo,
                referredByInfo: formDataValues?.referredByInfo,
                proceduresInfo: formDataValues?.proceduresInfo,
                specialInstruction: formDataValues?.specialInstruction,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
                cache: 'no-cache'
            });
            if(response.status === 201){
                toast.success("Patient form submitted successfully");
                setIsSubmitting(true);
            }
        } catch (error) {
            toast.error(error?.response?.data?.metadata?.errorMessage);
            
        }
    };

   

    useEffect(() => {
        if(isSubmitting){
            window.scrollTo(0, 0);
            window.location.reload();
        };
        const handleChange = () => {
            setIsDirty(true);
        }
        document.querySelectorAll("input, textarea, select").forEach(input => {
            input.addEventListener("input", handleChange);
        });
        const handleBeforeUnload = (event) => {
            if (isDirty) {
                event.preventDefault();
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.querySelectorAll("input, textarea, select").forEach(input => {
                input.removeEventListener("input", handleChange);
            });
        }
    }, [isDirty,isSubmitting]);


    return (
        <Content className={styles.openAccessWrapper}>
            <form onSubmit={handleSubmit}>
                <PatientForm />
                <EmployerForm />
                <ReferredByForm />
                <ProceduresForm />
                <SpecialInstructions />
                <Content style={{width:'100%'}}>
                <ReCAPTCHA
                  sitekey={CAPTCHA_SITE_KEY}
                  onChange={(token) => setCaptchaToken(token)}
                  className={styles.captchaStyle}
                  theme="light"
                    size="normal"
                  />
                </Content>
                <Content className={styles.buttonWrapper}>
                <Row 
                justify={'center'}
                gutter={16}>
                    <div className={styles.buttonParent}>
                            <Button type='primary' variant='contained' className={styles.button} fullWidth>Cancel</Button>
                            <Button htmlType='submit' disabled={!captchaToken} type='primary' variant='contained' className={styles.button} fullWidth>Submit</Button>
                        
                        </div>
                    </Row>
                </Content>
            </form>
        </Content>
    );
};

export default OpenAccessPatientForm;

